import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import API from '../../api';

import { useRefreshToken } from '../../common/hooks/useRefreshToken';
import Loader from '../../components/Loader';
import notify from '../../components/Notification/helper';
import ViewPage from '../../layouts/ViewPage';
import LabelAndDisplay from '../../components/LabelAndDisplay';
import ImageContainer from '../../components/shared/ImageContainer';

function QrCodeView() {
  const params = useParams();

  const qrCodeId = params.qrCodeId;

  const retailer = useSelector(state => state.retailer);

  useRefreshToken();

  const [qrCodePayload, setQrCodePayload] = useState({ name: '', url: '', retailer: retailer.id });
  const [fields, setFields] = useState([]);
  const [sidebarFields, setSidebarFields] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!qrCodeId) return;

    // if qrCodeId exists then fetch qr code
    // set payload
    makeGetQrCodeRequest();
  }, [qrCodeId]);

  const makeGetQrCodeRequest = async () => {
    try {
      setLoading(true);

      const qrCodeResponse = await API.getQrCode(qrCodeId);
      setQrCodePayload({ id: qrCodeId, name: qrCodeResponse.name, url: qrCodeResponse.url, retailer: retailer.id });

      setFields([
        {
          key: 'Name',
          value: qrCodeResponse.name
        },
        {
          key: 'URL',
          value: qrCodeResponse.url
        },
      ]);

      setSidebarFields([
        {
          key: 'QR Code',
          children: (
            <ImageContainer
              url={`https://chart.googleapis.com/chart?cht=qr&chs=450x450&chl=${qrCodeResponse.url}`}
              alt={qrCodeResponse.name}
            />
          )
        }
      ])
    } catch (error) {
      notify('error', 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <ViewPage
        title={qrCodePayload.name}
        onDelete={() => { }}
        breadcrumbsLinks={[
          {
            url: '/recipes-menu',
            content: 'Content Library',
          },
          {
            url: '/codes-menu',
            content: 'Codes',
          },
          {
            url: '/qr-codes',
            content: 'QR Codes',
          },
        ]}
      >
        <Box sx={{ flexGrow: 1, my: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7} lg={8}>
              <Box sx={{ flexGrow: 1, my: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {
                      fields.map(field => (
                        <LabelAndDisplay
                          key={field.key}
                          label={field.key}
                          value={field.value}
                        >
                          {field.children}
                        </LabelAndDisplay>
                      ))
                    }
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} md={5} lg={4}>
              <Box sx={{ flexGrow: 1, my: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {
                      sidebarFields.map(field => (
                        <LabelAndDisplay
                          direction='column'
                          key={field.key}
                          label={field.key}
                          value={field.value}
                        >
                          {field.children}
                        </LabelAndDisplay>
                      ))
                    }
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </ViewPage>
    </>
  )
}

export default QrCodeView